import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20of%20an%20ethereal%20dreamlike%20landscape%20with%20floating%20cherry%20blossom%20petals%2C%20soft%20golden%20hour%20light%20streaming%20through%20clouds%2C%20silhouettes%20of%20distant%20figures%2C%20atmospheric%20and%20emotional%20composition%2C%20warm%20coral%20and%20amber%20gradients%2C%20painterly%20texture%2C%20cinematic%20widescreen&width=1920&height=1080&seq=yanmu-hero-bg&orientation=landscape"
        alt="艳姆1—6系列"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 leading-tight">
            艳姆1—6完整系列介绍与内容解析
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            全面解读艳姆1—6各集剧情、人物设定与系列亮点，为您提供一站式的内容概览与观看指引
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/plot-analysis"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              查看剧情解析
            </Link>
            <Link
              to="/category/viewing-guide"
              className="px-8 py-3 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap"
            >
              观看指引
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}